import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { IAddon } from '@bca-shared/models/addon';

@Component({
  selector: 'bca-product-addon',
  templateUrl: 'product-addon.component.html',
  styleUrls: ['product-addon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductAddonComponent {
  @Input()
  addon: IAddon;

  @Output()
  delete = new EventEmitter<IAddon>();
}
